module.exports = {
  schema: {
    name: '公司資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '公司編號',
      },
      name: {
        type: 'String',
        name: '公司名稱',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key' },
        { key: 'name' },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/companies.js